import { PublicClientApplication } from '@azure/msal-browser';
import randomBytes from 'randombytes';

/**
 * Manage MSAL authentication
 */
export class MsalAuthService {
	/**
	 * @param {IdentityService} Identity
	 */
	constructor(Identity) {
		'ngInject';
		/**
		 * @type {IdentityService}
		 */
		this.Identity = Identity;
		this.msal = null;
	}

	/*
	 * Retrieve auth access token. Performed via popup.
	 * @param promptType String The type of auth being performed
	 *   When 'none', we try to obtain an access token without user intervention.
	 *   When 'consent', we obtain the token with the user's help.
	 * @return string
	 */
	async getAccessToken(promptType = 'none') {
		await this.setMsalInstance();
		const accessScopes = ['ChannelMessage.Send', 'Team.ReadBasic.All', 'Channel.ReadBasic.All'];
		const userEmail = this.Identity.user().email;
		const state = randomBytes(20).toString('hex');
		const loginRequest = {
			scopes: accessScopes,
			redirectUri: `${window.BASE_URL}/hub`,
			responseMode: 'form_post',
			loginHint: userEmail,
			prompt: promptType,
			state: state,
		};
		let loginResp = null;
		let accessToken = null;
		loginResp = await this.msal.loginPopup(loginRequest);
		this.validateLoginResp(loginResp, state);
		accessToken = loginResp.accessToken;
		return accessToken;
	}

	/*
	 * Initializes the Graph-api client
	 * @return Promise that resolves to the Graph-client instance.
	 * @throws
	 */
	async setMsalInstance() {
		if (this.msal) {
			return;
		}

		const appClientId = window.MS_TEAMS_PUSH_CLIENT_ID;
		if (!appClientId) {
			throw 'Missing push-to-teams client configuration';
		}
		const config = {
			auth: {
				clientId: appClientId,
				authority: 'https://login.microsoftonline.com/common/',
			},
			cache: {
				cacheLocation: 'localStorage',
			},
		};
		this.msal = await new PublicClientApplication(config);
	}

	/*
	 * Auth-response validation.
	 * @param respJson Object Response from login action
	 * @param stateParam String Random bytes generated by us and passed back from Graph for verification
	 * @throws
	 */
	validateLoginResp(respJson, stateParam) {
		if (!respJson || !respJson.accessToken) {
			throw `Missing access token`;
		}

		if (!respJson.state || respJson.state !== stateParam) {
			throw `State validation failed`;
		}
	}
}
